var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"visual-atmosphere",attrs:{"aria-hidden":"true"}},[_c('div',{staticClass:"atmosphere-beam"}),_c('div',{staticClass:"atmosphere-orbit"}),_c('div',{staticClass:"atmosphere-grain"})])
}]

export { render, staticRenderFns }